import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import image1 from "../assets/background/OptiView2_main_page_1B.webp";
import image2 from "../assets/background/OptiView2_main_page_2C.webp";
import image3 from "../assets/background/OptiView2_main_page_3B.webp";
import image4 from "../assets/background/OptiView2_main_page_5.webp";
import image5 from "../assets/background/OptiView2_main_page_6B.webp";

const Outlet = lazy(() =>
	import("react-router-dom").then((module) => ({ default: module.Outlet })),
);

const images = [image1, image2, image3, image4, image5];

const AuthLayout = () => {
	const { t, i18n } = useTranslation();
	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [loadedImages, setLoadedImages] = useState(Array(images.length).fill(false));
	const bgRef = useRef(null);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
		}, 5000);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setLoadedImages((prev) =>
							prev.map((loaded, index) => index === currentImageIndex || loaded),
						);
					}
				});
			},
			{ threshold: 0.1 },
		);

		if (bgRef.current) observer.observe(bgRef.current);
		return () => observer.disconnect();
	}, [currentImageIndex]);

	return (
		<div
			ref={bgRef}
			className="flex min-h-screen flex-col items-center justify-center bg-dark-blue"
			style={{
				backgroundImage: loadedImages[currentImageIndex]
					? `url(${images[currentImageIndex]})`
					: "none",
				backgroundSize: "cover",
				backgroundPosition: "center",
			}}
		>
			<header className="flex w-full items-center px-8 pt-4">
				<div className="container flex items-center justify-between">
					{/* <Link
            to="/"
            className="text-xl font-bold text-blue-600 flex items-center p-2"
          >
            <img
              src={logo}
              alt="Logo"
              loading="eager"
              width="150"
              height="80"
            />
          </Link> */}
				</div>
			</header>

			<main className="flex w-full flex-1 items-center justify-end p-8">
				<Suspense
					fallback={
						<div className="flex h-screen items-center justify-center bg-transparent">
							<div className="h-16 w-16 animate-spin rounded-full border-2 border-gray-900 border-t-transparent"></div>
						</div>
					}
				>
					<Outlet />
				</Suspense>
			</main>

			<footer className="flex w-full flex-col items-center justify-between gap-2 px-4 pb-4 text-center sm:flex-row sm:gap-0 sm:px-6 sm:text-left md:px-8">
				<p className="font-normal text-white text-xs leading-6 md:text-base md:leading-7">
					&copy; {new Date().getFullYear()} <span className="font-bold">IEC TELECOM.</span>{" "}
					<span className="font-normal">{t("rights_reserved")}</span>
				</p>

				<a
					href={`${import.meta.env.VITE_IEC_WEBSITE}`}
					target="_blank"
					rel="noopener noreferrer"
					className="font-semibold text-white text-xs hover:underline md:text-base"
				>
					{t("visit_website")}
				</a>
			</footer>
		</div>
	);
};

export default AuthLayout;
